import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Uncaught error:', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', padding: '2rem', textAlign: 'center',
        fontFamily: 'Inter, system-ui, sans-serif', color: '#F2F0ED', background: '#1C1C1E',
      }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Something went wrong</h1>
        <p style={{ opacity: 0.6, marginBottom: '1.5rem', maxWidth: '400px' }}>
          An unexpected error occurred. Try reloading the page.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button
            onClick={this.handleReload}
            style={{
              padding: '0.6rem 1.5rem', border: 'none', borderRadius: '6px',
              background: '#D4AF37', color: '#1C1C1E', fontWeight: 600,
              cursor: 'pointer', fontSize: '0.9rem',
            }}
          >
            Reload Page
          </button>
          <button
            onClick={this.handleGoHome}
            style={{
              padding: '0.6rem 1.5rem', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '6px',
              background: 'transparent', color: '#F2F0ED', fontWeight: 500,
              cursor: 'pointer', fontSize: '0.9rem',
            }}
          >
            Go Home
          </button>
        </div>
      </div>
    );
  }
}
